<template>
  <div >

   <router-link to='/luckyGrid'>
 <button>九宫格 </button>
</router-link>
<router-link to='/luckyWheel'>
 <button>大转盘</button>
</router-link>



  </div>
</template>

<script>
import { LuckyWheel, LuckyGrid } from 'vue-luck-draw'

export default {
  name: 'HelloWorld',
      components: {
      LuckyWheel,
      LuckyGrid
    },
 data () {
    return {

    }
  },
  mounted () {
    
  },
  methods: {

  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue